import { Container, CustomAside, Div, LinearProgressDiv, CustomLinearProgress, Footer } from "./style"
import photo from "../../Assets/profile.jpg"
import { CircularProgress,Typography } from "@mui/material"
import { AiFillLinkedin } from "react-icons/ai"
import { FaGithubSquare } from "react-icons/fa"
import { SiGmail } from "react-icons/si"
import { Box } from "@mui/system"

const Aside = () =>{
    return(
        <>
        <CustomAside>
            <section>
                <img src={photo}/>
                <h3>Pedro Henrique</h3>
                <p>Desenvolvedor Front-end</p>
            </section>
            <Container>
                <h4>Estado: <span>Bahia</span></h4>
                <h4>Cidade: <span>Pojuca</span></h4>
                <h4>Idade: <span>24</span></h4>
            </Container>
            <Container>
                <Div>
                    <Box>
                        <CircularProgress 
                            variant="determinate"
                            value={100}
                        />
                        <Typography>100%</Typography>
                        <Typography component="h5">Português</Typography>
                    </Box>
                    <Box>
                        <CircularProgress 
                            variant="determinate"
                            value={50}
                        />
                        <Typography>50%</Typography>
                        <Typography component="h5">Inglês</Typography>
                    </Box>
                </Div>
            </Container>
            <Container>
                <LinearProgressDiv>
                    <Typography component="h5">HTML <span>100%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={100}/>
                </LinearProgressDiv>
                <LinearProgressDiv>
                    <Typography component="h5">CSS <span>80%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={80}/>
                </LinearProgressDiv>
                <LinearProgressDiv>
                    <Typography component="h5">JavaScript <span>80%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={80}/>
                </LinearProgressDiv>
                <LinearProgressDiv>
                    <Typography component="h5">ReactJs <span>70%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={70}/>
                </LinearProgressDiv>
                <LinearProgressDiv>
                    <Typography component="h5">Typescript <span>70%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={70}/>
                </LinearProgressDiv>
                <LinearProgressDiv>
                    <Typography component="h5">PostgreSQL <span>70%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={70}/>
                </LinearProgressDiv>
                <LinearProgressDiv>
                    <Typography component="h5">GIT <span>90%</span></Typography>
                    <CustomLinearProgress variant="determinate" value={90}/>
                </LinearProgressDiv>
            </Container>
            <Footer>
                <a href={"https://github.com/pedrohtbl"} target="_blank">
                    <FaGithubSquare/>
                </a>
                <a href={"https://www.linkedin.com/in/pedro-htbl/"} target="_blank">
                    <AiFillLinkedin/>
                </a>
                <a href="mailto:pedrohtbl@gmail.com">
                    <SiGmail/>
                </a>
              
            </Footer>
        </CustomAside>
        </>
    )
}

export default Aside